import React from "react";
import Medicine from "../../Components/Admin/Medicine/Medicine";

const AdminMedicinePage = () => {
  return (
    <div className="p-5">
      <Medicine />
    </div>
  );
};

export default AdminMedicinePage;
